/**
 * 直接搜索Main可以查看当前页面的主要内容
 */
import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { message } from "antd";
import Cookies from "js-cookie";
import withLayout from "../../layouts/withLayout";
import { QueryClient, useQuery } from "react-query";
import { useLocalStorageState, useMount, useSetState } from "ahooks";
import { isObject, isUndefined, pickBy } from "lodash";
import qs from "qs";
import { Modal } from "@t8891/pc-v1";
import {
  fetchInquiry,
  fetchInquiryBuyCarInformation,
  fetchInquiryBuyCarInformationOption,
  fetchInquiryByRoster,
  fetchInquiryKind,
  fetchActiveInfo,
} from "@Services/api";
import { BottomFillIcon, CrossIcon, SuccessIcon, TopFillIcon } from "@t8891/icon";
import { gaEvent } from "@Lib/ga";
import { IInquiryKind } from "@Types/inquiry";
import AdIframe from "../../components/ad/adIframeTs";
import "@Styles/global.less";
import styles from "./price.module.less";
import InquiryForm, { FormParams } from "@Components/ask/inquiryForm";
import { IOptions } from "@Types/common";
import CompeteModal from "@Components/ask/CompeteModal";
import BrandDesc from "@Components/ask/BrandDesc";
import Crumbs from "@Components/ask/Crumbs";
import AdvantageItem from "@Components/ask/AdvantageItem";
import InquiryProcessModal from "@Components/ask/InquiryProcessBModal";
import { appendParamsToUrl, g4 } from "../../utils/helper";
import { AskPriceQrCode } from "@Components/campaigns/2024/common";
import { activityAtom } from "@Lib/jotai/activity";
import { useAtom } from "jotai";
import { sendInquiryAds, sendInquiryAdsRemarketing, sendAgentAdsRemarketing } from "@Lib/adsRemarking";
import SplitText from "@Components/SplitText";
import KindSelect from "@Components/CarSelect/kindSelect";
import { Mask } from "@t8891/pc";
import { Status_4_Result } from "@Components/buyCarMenu/Result.tsx";

const inquiryStoryLists: IOptions[] = [
  { name: "了解優惠", value: "1" },
  { name: "比較車款", value: "2" },
  { name: "預備購車", value: "3" },
  { name: "其他", value: "100" },
];

export enum EAskPriceType {
  /** 名单广告 */
  ROSTER = "roster",
  /** 广告落地页 */
  AD = "ad",
}

/** Main */
const AskPricePage: React.FC<any> = ({ abTest }) => {
  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [tipsModalVisible, setTipsModalVisible] = useState(false);
  const [showCompeteModal, toggleCompeteModal] = useState(false);
  const [showBrandSelect, setShowBrandSelect] = useState(false);
  const [contentWarning, setContentWarning] = useState("");
  const [ads, setAds] = useState<any>({});
  // const [activityInfo, setActiveInfo] = useState<any>();
  // const [activityModal, setActivityModal] = useState(false);
  // const [activityQrCode, setActivityQrCode] = useState("");

  const {
    globalSource,
    myid,
    b: urlBrandId,
    k: urlKindId,
    source: urlSource,
    type,
    kindType,
  } = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  });

  const [modalData, setModalData] = useState<any>({
    inquiryId: "",
    buyCarInformationStatus: 0,
    activity: {},
    buyCarTime: 0,
    selectRegion: "",
    selectRegionAreas: "",
  });
  const [inquiryData, setInquiryData] = useLocalStorageState("inquiryData", {
    defaultValue: {},
  });

  const [pageState, setPageState] = useSetState({ type });
  const [adBanner, setAdBanner] = useState("");

  const getCurrentSource = () => {
    if (kindType === EAskPriceType.AD) {
      return "廣告落地頁";
    }
    return undefined;
  };

  const source = getCurrentSource() || urlSource;
  // 外部页面可以管控b，k
  const [current, setCurrent] = useSetState({ b: urlBrandId, k: urlKindId });

  const { b, k } = current;

  // 名单广告不显示广告内容
  const isRoster = pageState.type === EAskPriceType.ROSTER;

  const [inquiryOptions, setInquiryOptions] = useSetState({
    buyCarTime: [] as IOptions[],
    contactTime: [] as IOptions[],
    inquiryStory: [] as IOptions[],
  });

  const brandRef = useRef<string>("");
  
  /** 詢價車款數據 */
  const { data: kindData } = useQuery(["fetchInquiryKind", k], async () => {
    const res = await fetchInquiryKind({
      k,
      myid: myid || 0,
    });

    if (res.data.kindId === 0 || res?.status === 13000) {
      setShowBrandSelect(true);
    }
    if (!kindType && res.data.type) {
      setPageState({ type: res.data.type });
    }

    if (res.data.adBanner) {
      setAdBanner(res.data.adBanner);
    }

    if (res?.status === 12000) {
      return res.data as IInquiryKind;
    }

    return {} as IInquiryKind;
  });

  const addMountRTBHEvents = () => {
    const userMessage = localStorage.getItem("userMessage");
    (window.rtbhEvents = window.rtbhEvents || []).push(
      {
        eventType: "startorder",
      },
      {
        eventType: "uid",
        id: window?.loginMid || (!!userMessage ? JSON.parse(userMessage).mId : "unknown"),
      },
    );
  };

  useMount(async () => {
    // 获取购车咨询选择内容
    const res = await fetchInquiryBuyCarInformationOption({ inquiryId: modalData.inquiryId });
    if (res?.status === 12000) {
      const { buyCarTime, contactTime, inquiryStory } = res?.data || {};
      setInquiryOptions({
        buyCarTime,
        contactTime,
        inquiryStory: inquiryStory || inquiryStoryLists,
      });
    }

    if (globalSource) {
      Cookies.set("globalSource", globalSource, { expires: 10 });
      Cookies.set("globalSessionSource", globalSource);
    }
    if (isObject(window)) {
      addMountRTBHEvents();
      window.onbeforeunload = () => {
        window.localStorage.setItem("test_onbeforeunload", "銷售線索");
        gaEvent("銷售線索", "一鍵詢價頁", "放棄詢價");
      };
    }
  });

  const postInquiry = async (queryData: any) => {
    const {
      name,
      b,
      k,
      source,
      mobile,
      brandName,
      kindName,
      agencyAgreement,
      region,
      regionName,
      section,
      dealer,
      purchases,
      reason,
      age,
      email,
    } = queryData;

    const inquiryData = {
      element_id: source,
      brand_id: kindData?.brandId || b,
      kind_id: kindData?.kindId || k,
      model_id: "",
      brand: brandName,
      kind: kindName,
      model: "",
      inquiry_city: regionName,
      mobile_number: mobile,
      section,
      dealer,
      purchases,
      reason,
      age,
      email,
    };
    g4("inquiry_submit", inquiryData);

    const res = isRoster
      ? await fetchInquiryByRoster({ ...queryData, b: kindData?.brandId || b, k: kindData?.kindId || k })
      : await fetchInquiry({
          ...queryData,
          b: kindData?.brandId || b,
          k: kindData?.kindId || k,
        });

    if (res.status === 13001) {
      setContentWarning(res.data?.message);
      return;
    }

    // 请求错误直接提示
    if (res.status !== 12000) {
      message.error({ content: res.data.message || "係統錯誤", style: { marginTop: "20%" } });
      return;
    }

    g4("inquiry_success", { ...inquiryData, inquiry_id: res.data.inquiryId });

    setInquiryData({
      name,
      mobile,
      agencyAgreement,
      codeVerify: 0,
      region: region,
    });

    setModalData({
      inquiryId: res.data.inquiryId,
      activity: res.data.activity,
      buyCarInformationStatus: res.data.buyCarInformationStatus,
      buyCarTime: res.data.buyCarTime,
      selectRegion: res.data.selectRegion,
      selectRegionAreas: res.data.selectRegionAreas,
    });

    addRTBHEvents(res.data.inquiryId, [k], res.data.mid);
    Cookies.set("isAskPrice", "true", { expires: 30 });
    localStorage.setItem("userMessage", JSON.stringify({ mId: res.data.mid }));
    if (res.data.noRepeatInquiry === 1) {
      gaEvent("銷售線索", "一鍵詢價頁", "詢價買家");
      if (window.fbq) {
        window.fbq("trackCustom", "新車-詢價-詢價買家");
      }
    }

    if (res.data?.recommend?.length !== 0) {
      gaEvent("銷售線索", "詢價-提交成功頁", "顯示");
    }
    gaEvent("銷售線索", "一鍵詢價頁", "我要詢價");

    // 增强型转化跟踪
    sendInquiryAds();

    // ADS再营销跟踪
    sendInquiryAdsRemarketing();

    // ADS再营销跟踪-業代優惠
    sendAgentAdsRemarketing();

    if (res.status === 12000 && isRoster) {
      location.href = `/re-ask/price?rosterId=${res.data.id}`;
      return;
    }

    setTimeout(() => {
      location.href = `/re-ask/price?inquiryId=${res.data.inquiryId}`;
    }, 200);
  };
  const [showKindSelect, toggleSelect] = useState(false);

  const handleKindSelectChange = (key: "index" | "brand" | "kind", data: any) => {
    key === "brand" && (brandRef.current = data.id);
    if (key === "kind") {
      toggleSelect(false);
      setCurrent({ k: data.id });
      appendParamsToUrl({ b: brandRef.current, k: data.id });
    }
  };

  const handleProcessSubmit = async (value: FormParams, setBuyCarInformation: () => void) => {
    const requestParams = pickBy(value, (v) => {
      return !isUndefined(v);
    });
    const params = { ...requestParams, inquiryId: modalData.inquiryId };

    const res = await fetchInquiryBuyCarInformation(params);
    if (res.status === 12000) {
      setSuccessModalVisible(false);
      setTipsModalVisible(true);
      setBuyCarInformation();
    } else {
      message.error(res.message);
    }
  };

  const addRTBHEvents = (inquiryId: string, kindsId: string[], m_id: string) => {
    if (!kindsId.length) return;
    (window.rtbhEvents = window.rtbhEvents || []).push(
      {
        eventType: "conversion",
        conversionClass: "action",
        conversionSubClass: "form",
        conversionId: inquiryId,
        offerIds: kindsId,
        conversionValue: 1,
        conversionCurrency: null,
      },
      {
        eventType: "uid",
        id: window?.loginMid || "unknown",
      },
    );
  };

  const handleSubmit = async (value: FormParams) => {
    const { source: querySource } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
    const sourceCurrent = Cookies.get("globalSource") || source;

    const {
      name,
      mobile,
      code,
      agencyAgreement,
      region,
      codeVerify,
      crossRegion,
      buyCarTime,
      contactTime,
      regionName,
      sex,
      inquiryStory,
      inquiryStoryRemark,
      isSeeCar,
      section,
      dealer,
      purchases,
      reason,
      age,
      email,
    } = value;

    const params = {
      b,
      k,
      myid,
      name,
      mobile,
      source: !!sourceCurrent ? sourceCurrent : abTest,
      entrance: querySource || "",
      agencyAgreement,
      code,
      brandName: kindData?.brandName,
      kindName: kindData?.kindName,
      region: region,
      sex,
      codeVerify,
      buyCarTime,
      crossRegion,
      section,
      dealer,
      purchases,
      reason,
      regionName,
      contactTime,
      inquiryStory,
      inquiryStoryRemark,
      isSeeCar,
      age,
      email,
    };

    g4("element_exposured", {
      page_name: "一鍵詢價頁",
      page_module: "詢價提醒彈窗",
      element: "放棄詢價",
      element_id: "放棄詢價",
      business: "銷售線索",
    });

    postInquiry(params);
  };
  const [activityInfo] = useAtom(activityAtom);

  return (
    <section>
      <Status_4_Result
        visible={!!contentWarning}
        content={contentWarning}
        onClose={() => {
          setContentWarning("");
        }}
      />
      {/* 白色找车标题区域 */}
      {/* <BaseBreadcrumb /> */}
      {/* 主区域 */}
      <div className={styles["ask-price-bg"]}>
        <>
          <Crumbs b={b as string} k={k as string} brandName={kindData?.brandName} kindName={kindData?.kindName} />
          <section className={styles["askPrice"]}>
            <section className={styles["content"]}>
              {!isRoster && (
                <>
                  {/* <AdIframe
                    slot={"/173427088/newcar_pc_cluesubmit_top"}
                    size={[["fluid"], ["fluid"]]}
                    styles={{ width: "1190px", height: "130px", zIndex: 1 }}
                  /> */}
                  <AdvantageItem note={kindData?.note} />
                </>
              )}
              <div className={styles["brand-content-item"]} id='askPriceContent'>
                <BrandDesc kindData={kindData!} isHide={isRoster} adBanner={adBanner} activityInfo={activityInfo} type={pageState.type} />
                <div className={styles["list"]}>
                  <div style={{ marginTop: "80px" }}>
                    {showBrandSelect && (
                      <section className='w-full relative mb-24 flex items-center'>
                        <div className={`flex w-86 relative`}>
                          <span className='absolute text-[#ff4333] -left-10 to-4'>*</span>
                          <SplitText
                            label='車款'
                            width={64}
                            cls='text-[#333] font-medium text-16 leading-18'
                          ></SplitText>
                          ：
                        </div>
                        <div
                          className={`${
                            !!kindData?.brandName ? "text-[#333]" : "text-[#BBB]"
                          } pl-10 rounded-4 border-1 border-solid border-[#e8e8e8]  relative inline-flex items-center text-14 cursor-pointer flex-1 h-30 leading-30`}
                          onClick={() => {
                            toggleSelect(true);
                          }}
                        >
                          <div className='w-full' data-value={`${kindData?.brandName} ${kindData?.kindName}`}>
                            {!!kindData?.brandName ? `${kindData?.brandName} ${kindData?.kindName}` : `請選擇廠牌車款`}
                          </div>
                          <div className='absolute right-4 top-3'>
                            {showKindSelect ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
                          </div>
                          <KindSelect
                            setOpen={toggleSelect}
                            open={showKindSelect}
                            onChange={handleKindSelectChange}
                            className='absolute left-0 top-30 z-30'
                          />
                        </div>
                      </section>
                    )}

                    <InquiryForm
                      source={source as string}
                      kindData={kindData!}
                      isRoster={isRoster}
                      inquiryData={inquiryData}
                      onSubmit={handleSubmit}
                      inquiryOptions={inquiryOptions}
                      type={(pageState.type || "") as string}
                      kindType={kindType as string}
                      isHideAnswerDate={!isRoster}
                    />
                  </div>
                </div>
              </div>
            </section>
          </section>
        </>
      </div>
      {/* 弹窗区域 */}
      <Modal maskClosable={true} visible={tipsModalVisible} className={styles["modal-inquiry-tips"]}>
        <section className={styles["tips-modal"]}>
          <CrossIcon
            className={styles["cross-icon"]}
            size={12}
            fill='#333'
            onClick={() => {
              setTipsModalVisible(false);
            }}
          />
          <div className={styles["tips-modal-icon"]}>
            <SuccessIcon size={40} fill='#37AF50' />
          </div>
          <div className={styles["tips-modal-title"]}>提交成功</div>
        </section>
      </Modal>
      <InquiryProcessModal
        visible={successModalVisible}
        setVisible={setSuccessModalVisible}
        inquiryId={modalData.inquiryId}
        onSubmit={handleProcessSubmit}
      />
      <CompeteModal visible={showCompeteModal} setVisible={toggleCompeteModal} data={ads} setData={setAds} />
      {/* {activityModal && (
        <AskPriceQrCode
          qrCode={activityQrCode}
          onClose={() => {
            setActivityModal(false);
          }}
        />
      )} */}
    </section>
  );
};

export default AskPricePage;
